import { useMutation, useQuery } from "@apollo/client";
import { Button, CheckoutModal } from "@kompare/kompare-ui-library";
import React from "react";
import { i18n, RootState, setGlobalLoading, showMessage, useAppDispatch, useAppSelector } from "src/common";
import { sendTermsAndConditionsToEmailAdditional } from "src/common/api/apollo/additional/mutations";
import { getTermsAndConditionsAdditional } from "src/common/api/apollo/additional/queries";
import { GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables } from "src/common/api/apollo/additional/types/types";
import { Flex, Loader } from 'src/components';
import { TermsCard } from "../cards/additional";


export interface TermsAndConditionsAdditionalProps {
  open?: boolean;
  title?: string;
  onClose?: () => void;
}

export const TermsAndConditionsAdditionalModal = ({ open = false, title = i18n.t('components.modals.termsAndConditionsModal.title'), onClose }: TermsAndConditionsAdditionalProps) => {
  const offerId = useAppSelector((store: RootState) => store.state?.modal?.termsAndConditionsAdditionalModal?.offerId);

  const { data: getTermsAndConditionsData, loading: termsAndConditionsLoading } = useQuery<GetTermsAndConditionsFromFilesQuery, GetTermsAndConditionsFromFilesQueryVariables>(getTermsAndConditionsAdditional, {
    variables: { id: offerId || '' },
    skip: !offerId,
    fetchPolicy: 'network-only',
  });

  const [sendTermsAndConditionsToEmail] = useMutation(sendTermsAndConditionsToEmailAdditional);

  const dispatch = useAppDispatch();

  if (termsAndConditionsLoading) {
    return <Loader page={true} />;
  }
  return (
    <CheckoutModal title={title} open={open} onClose={() => onClose?.()}>
      <Flex vertical gap={12}>
        <TermsCard termsAndConditions={getTermsAndConditionsData?.getTermsAndConditionsFromFiles} isModal={true} />
        <Button type="button" btnType="outlinePrimary" text={i18n.t('components.modals.termsAndConditionsAdditionalModal.sendToEmail')} onClick={() => {
          dispatch(setGlobalLoading(true));
          sendTermsAndConditionsToEmail({ variables: { offerId: offerId || '' } }).then(() => {
            dispatch(setGlobalLoading(false));
            onClose?.();
            dispatch(showMessage({ message: i18n.t('components.modals.termsAndConditionsAdditionalModal.sentToEmail'), type: 'success', duration: 5000 }));
          }).catch(() => {
            dispatch(setGlobalLoading(false));
            dispatch(showMessage({ message: i18n.t('common.globalError'), type: 'error', duration: 5000 }));
          });
        }} />
      </Flex>
    </CheckoutModal>
  );
};
